import {
  FormReducerAction,
  FormReducerActionPayloadMinimumPhotos,
  FormReducerActionPayloadPriceRules,
  FormReducerKind,
  FormReducerState
} from '../contexts/types/ad';

export const initialFormsState = {};

export function formsReducer(state: FormReducerState, action: FormReducerAction): FormReducerState {
  if (action.type === FormReducerKind.SET_PRICE_RULES) {
    return {
      ...state,
      priceRules: action.payload as FormReducerActionPayloadPriceRules
    };
  }
  if (action.type === FormReducerKind.SET_MINIMUM_PHOTOS) {
    return {
      ...state,
      minimumPhotos: action.payload as FormReducerActionPayloadMinimumPhotos
    };
  }
  if (action.type === FormReducerKind.SET_MODEL_YEARS) {
    return {
      ...state,
      modelYears: action.payload as Array<number>
    };
  }
  if (action.type === FormReducerKind.INVALIDATE_PRICES_CACHE) {
    return {
      ...state,
      priceRules: undefined
    };
  }
  if (action.type === FormReducerKind.INVALIDATE_CACHE) {
    return {};
  }
  return state;
}
